import directive from './v-click-outside';

export default {
  install(Vue) {
    Vue.directive('click-outside', directive)
  },
  directive,
}
